<template>
  <div class="main">
    <div class="logo"></div>
    <div class="content login">
      <div class="ipt-box font-size14">
        <mobile-input @btnEnable="btnEnable" @btnDisable="btnDisable" @hideImgCode="getNcode" :inputType="CONF.inputType.mobileOrEmail" :errData="errData"></mobile-input>
        <div class="account-ipt">
          <input class="input" :class="{'error':errMsgShow}" maxlength="20" placeholder="密码" type="password" v-model="password"  v-on:focus="pwdFocus"/>
          <div class="msg-box" v-show="errMsgShow&&!isMobile">
            <div class="icon"></div>
            <div class="text color-msg font-size12">{{errMsg}}</div>
          </div>
        </div>
        <div class="account-btn"  v-show="submitBtnState == CONF.submitBtnState.enable" @click="login()">登&nbsp;录</div>
        <div  class="account-btn disable" v-show="submitBtnState == CONF.submitBtnState.disable">登&nbsp;录</div>
      </div>
      <div class="bottom-cue color-cue font-size14"><router-link :to="CONF.urlList.ResetGetAccount.path+search">忘记密码？</router-link></div>
      <other-way>
        <div class="option-account font-size14 color-link">
          <router-link :to="CONF.urlList.LoginCode.path+search">手机短信登录></router-link></div>
      </other-way>
    </div>
  </div>
</template>
<style>
  .content.login .bottom-cue{
    text-align: right;
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  import MobileInput from '../components/mobileInput'
  import OtherWay from '../components/otherWay'
  import MobileCode from '../components/mobileCode'
  import ImgCode from '../components/imgCode'
  export default {
    components: {MobileInput, OtherWay, MobileCode, ImgCode},
    data () {
      return {
        CONF: CONF,
        submitBtnState: CONF.submitBtnState.disable,
        mobile: '',
        password: '',
        countryCodeIndex: 0,
        inputType: CONF.inputType.mobile,
        errData: {},
        channel: '',
        isMobile: '',
        errMsgShow: false,
        errMsg: '',
        search: window.location.search
      }
    },
    created () {
      this.isMobile = server.isMobile()
      this.channel = server.getChannelType(this.$route.query.callback)
    },
    methods: {
// 按钮可用
      btnEnable (mobile, countryCodeIndex) {
        this.mobile = mobile
        this.countryCodeIndex = countryCodeIndex
        this.submitBtnState = CONF.submitBtnState.enable
      },
// 按钮不可用
      btnDisable () {
        this.submitBtnState = CONF.submitBtnState.disable
      },
// 隐藏图形验证码
      getNcode (countryCodeIndex) {
        if (countryCodeIndex !== undefined) {
          this.countryCodeIndex = countryCodeIndex
        }
      },
// 验证帐号格式
      getAccountType () {
        if ((this.countryCodeIndex === 0 && CONF.reg.chinaPhone.test(this.mobile)) || (this.countryCodeIndex !== 0 && CONF.reg.otherPhone.test(this.mobile))) {
          this.inputType = CONF.inputType.mobile
          return true
        } else {
          if (CONF.reg.email.test(this.mobile)) {
            this.inputType = CONF.inputType.mobileOrEmail
            return true
          } else {
            return false
          }
        }
      },
// 登陆
      login () {
        if (!this.getAccountType()) return
        if (this.password.length === 0) {
          this.showErrMsg(CONF.errorMsg.empty.pwd)
          return
        }
        let that = this
        this.submitBtnState = CONF.submitBtnState.disable
        let data = {}
        if (this.inputType === CONF.inputType.mobile) {
          data = {account: this.mobile, ncode: CONF.countryList[this.countryCodeIndex].code, password: this.password, channel: this.channel}
        } else {
          data = {account: this.mobile, password: this.password, channel: this.channel}
        }
        if (this.$route.query.connectid) {
          data.connectid = this.$route.query.connectid
        }
        server.appServices(this, CONF.APIList.accountLogin, data).then(res => {
          if (res.status === CONF.errCode.success.code) {
            if (that.$route.query.callback) {
              location.href = that.$route.query.callback
            } else {
              window.location.href = 'http://m.ismartv.cn'
            }
          } else {
            this.submitBtnState = CONF.submitBtnState.enable
            that.errData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
          }
        })
      },
      pwdFocus () {
        this.errMsgShow = false
      },
      showErrMsg (msg) {
        if (this.isMobile) {
          this.$toast({toastMsg: msg})
        }
        this.errMsgShow = true
        this.errMsg = msg
      }
    }
  }
</script>



// WEBPACK FOOTER //
// login.vue?2332f568